// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".list-group-item{border-bottom:1px solid #e0e0e0}", "",{"version":3,"sources":["webpack://./resources/js/views/store/newService.vue"],"names":[],"mappings":"AACA,iBACI,+BAAJ","sourcesContent":["\n.list-group-item {\n    border-bottom: 1px solid #e0e0e0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
